"use client";

import MainSidebar from "@/components/customs/MainSidebar";
import MainContentPendingOverlay from "./MainContentPendingOverlay";
import { useNavigationPending } from "./NavigationPendingContext";
import { cn } from "@/lib/utils";
import type { SupportedLanguage } from "@/lib/shared";
import type { TRole } from "@/actions/types";
import type { ReactNode } from "react";

function MainColumnWithOverlay({ children }: { children: ReactNode }) {
  const { navigationTarget } = useNavigationPending();

  return (
    <div className="flex-1 min-w-0 relative flex flex-col min-h-0">
      <div
        className={cn(
          "relative z-0 flex-1 min-h-0 min-w-0",
          navigationTarget &&
            "invisible pointer-events-none select-none [content-visibility:auto]",
        )}
        aria-hidden={navigationTarget ? true : undefined}
      >
        {children}
      </div>
      <MainContentPendingOverlay />
    </div>
  );
}

export default function MainLayoutWithNavigationPending({
  children,
  locale,
  role,
}: {
  children: ReactNode;
  locale: SupportedLanguage;
  role?: TRole;
}) {
  return (
    <div className="relative flex min-h-0 w-full flex-1">
      <MainSidebar locale={locale} role={role} />
      <MainColumnWithOverlay>{children}</MainColumnWithOverlay>
    </div>
  );
}
